import api from "@/lib/api";

const VID_KEY = "sx_vid";
const SID_KEY = "sx_sid";
const SID_TS = "sx_sid_ts";
const SESSION_TIMEOUT = 30 * 60 * 1000;

function uuid() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function getVisitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) {
    v = uuid();
    localStorage.setItem(VID_KEY, v);
  }
  return v;
}

export function getSessionId() {
  const now = Date.now();
  const last = parseInt(sessionStorage.getItem(SID_TS) || "0", 10);
  let s = sessionStorage.getItem(SID_KEY);
  if (!s || now - last > SESSION_TIMEOUT) {
    s = uuid();
    sessionStorage.setItem(SID_KEY, s);
  }
  sessionStorage.setItem(SID_TS, String(now));
  return s;
}

function deviceType() {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

function isAuthed() {
  return !!localStorage.getItem("siteux_token");
}

export function trackPageview(path, referrer, role) {
  try {
    api
      .post("/analytics/track", {
        visitor_id: getVisitorId(),
        session_id: getSessionId(),
        type: "pageview",
        path,
        referrer: referrer || "",
        device: deviceType(),
        authed: isAuthed(),
        role: role || "visitor",
      })
      .catch(() => {});
  } catch (e) {
    /* silent */
  }
}

export function trackLeave(path, durationMs, role) {
  try {
    const payload = {
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      type: "pageleave",
      path,
      device: deviceType(),
      duration_ms: Math.round(durationMs || 0),
      authed: isAuthed(),
      role: role || "visitor",
    };
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([JSON.stringify(payload)], { type: "application/json" }));
    } else {
      api.post("/analytics/track", payload).catch(() => {});
    }
  } catch (e) {
    /* silent */
  }
}
